import { call, put } from "redux-saga/effects";
import { apiGeneral, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { DownloadDocumentActions } from "store/ducks/documents";

export function* downloadDocumentRequest(action: any) {
  try {
    const { id, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.get,
      `/document-download/${id}`
    );

    const data = responseBody;
    yield put(DownloadDocumentActions.success(data));
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(DownloadDocumentActions.failure(errorMessage));
  }
}
